exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_wks-ext.js
 ** module id = 166
 ** module chunks = 0
 **/